type LandingUserData = {
  buildingId: unknown
  user: { role: string }
}

/** Where a freshly signed-in user lands, by role. */
export const getRoleLandingPath = ({ buildingId, user }: LandingUserData) => {
  if (buildingId === null) return '/dashboard/calendar'

  switch (user.role) {
    case 'Administrator':
    case 'Manager':
    case 'PropertyManager':
      return '/dashboard/building-analytics'
    case 'Staff':
      return '/dashboard/user-panel/profile'
    default:
      return '/dashboard/calendar'
  }
}
